import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { useDropzone } from "react-dropzone";

const ServicesCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [description, setDescription] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
 const [measurementUnitEn , setMeasurementUnitEn] = useState("");
 const [measurementUnit , setMeasurementUnit] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);

	const [files, setFiles] = useState([]);

	const [price , setPrice] = useState("") ;

	const dispatch = useDispatch();



	useEffect(() => {
		onStart();
	}, []);

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة سعر خدمة جديد",
				breadcrumb: "الاسعار",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const handlePicture = id => {
		const fileInput = document.querySelector(id);
		if (!fileInput) {
			console.error(`Element with ID "${id}" not found.`);
			return; // Exit the function early if the element isn't found
		}
		if (fileInput.files && fileInput.files[0]) {
			// Check if files exist and are not empty
				setPicture(URL.createObjectURL(fileInput.files[0]));
			
		} else {
			console.warn(`No file selected for ${id}`);
		
		}
	};
	const handleSubmit = async e => {
		e.preventDefault();
		const mainPicture = document.querySelector("#picture");
		if (mainPicture.files[0]) {
			try {
				setLoading(true);
				// Upload the second file (mainPicture)
				const mainPictureData = new FormData();
				mainPictureData.append("file", mainPicture.files[0]);
				const mainPictureResponse = await axios.post(
					`${process.env.REACT_APP_API_URL}/upload`,
					mainPictureData,
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
							"Content-Type": "multipart/form-data",
						},
					}
				);
				const data = {
					title: { ar: title, en: titleEn },
					description: { ar: description, en: descriptionEn },
					image: mainPictureResponse.data.data.name, 
					price : price,
					measurementUnit: { ar: measurementUnit, en: measurementUnitEn },
				};

				// Submit the main request with data
				await axios.post(
					`${process.env.REACT_APP_API_URL}/pricesList`,
					{
					
						 ...data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				);

				history.push("/servicesPrices/index");
				toast.success("تم اضافة الخدمة بنجاح!");
			} catch (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
			} finally {
				setLoading(false);
			}
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">

								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="title">العنوان</label>
										<input
											type="text"
											id="title"
											required
											value={title}
											onChange={e => setTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="titleEn">العنوان الانجليزي</label>
										<input
											type="text"
											id="titleEn"
											required
											dir="ltr"
											value={titleEn}
											onChange={e => setTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="description">الوصف</label>
										<input
											type="text"
											id="description"
											required
											onChange={e => setDescription(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="descriptionEn"> الوصف الانجليزي</label>
										<input
											type="text"
											id="descriptionEn"
											required
											dir="ltr"
											value={descriptionEn}
											onChange={e => setDescriptionEn(e.target.value)}
										/>
									</div>

								</div>

                                  <div className="row">
								<div className="form-item col-md-6 ">
									<label htmlFor="price">السعر</label>
									<input
										type="text"
										id="حقهؤث"
										required
										dir="rtl"
										value={price}
										onChange={e => setPrice(e.target.value)}
									/>
								</div>

								  </div>
								  <div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="measurementUnitAr">الترميز/وحدة القياس(عربي)</label>
										<input
											type="text"
											id="measurementUnitAr"
											required
											value={measurementUnit}
											onChange={e => setMeasurementUnit(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="measurementUnitEn"> الترميز/وحدة القياس(انجليزي)</label>
										<input
											type="text"
											id="measurementUnitEn"
											required
											dir="ltr"
											value={measurementUnitEn}
											onChange={e => setMeasurementUnitEn(e.target.value)}
										/>
									</div>

								</div>

							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input
										type="file"
										onChange={() => handlePicture("#picture")}
										id="picture"
									/>
									{picture && (
										<div className="img-holder">
											<img
												src={`${picture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button type="submit" className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = loader => {
		return new MyUploadAdapter(loader);
	};
}

class MyUploadAdapter {
	constructor(props) {
		this.loader = props;
		this.url = `${process.env.REACT_APP_API_URL}/upload`;
	}

	upload() {
		return new Promise((resolve, reject) => {
			this._initRequest();
			this._initListeners(resolve, reject);
			this._sendRequest();
		});
	}

	abort() {
		if (this.xhr) {
			this.xhr.abort();
		}
	}

	_initRequest() {
		const xhr = (this.xhr = new XMLHttpRequest());

		xhr.open("POST", this.url, true);
		xhr.responseType = "json";
		xhr.setRequestHeader("Authorization", `Bearer ${cookie.get("token")}`);
	}

	_initListeners(resolve, reject) {
		const xhr = this.xhr;
		const loader = this.loader;
		const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`;

		xhr.addEventListener("error", () => reject(genericErrorText));
		xhr.addEventListener("abort", () => reject());
		xhr.addEventListener("load", () => {
			const response = xhr.response;
			if (!response || response.error) {
				return reject(
					response && response.error ? response.error.message : genericErrorText
				);
			}
			resolve({
				default: response.data.filePath,
			});
		});

		if (xhr.upload) {
			xhr.upload.addEventListener("progress", evt => {
				if (evt.lengthComputable) {
					loader.uploadTotal = evt.total;
					loader.uploaded = evt.loaded;
				}
			});
		}
	}

	_sendRequest() {
		const data = new FormData();
		this.loader.file.then(result => {
			data.append("file", result);
			this.xhr.send(data);
		});
	}
}

export default ServicesCreate;
